module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_scout-a4ee8ac4145618867dad3adc08f14d20.png";